// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './vue/router'
import store from './vue/store/index'
import './vue/mixins'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './vue/resource/index'
import './vue/components'
import i18n from './vue/i18n/index'
import './vue/filters'
import UUID from 'vue-uuid'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueApexCharts from 'vue-apexcharts'
import VeeValidate from 'vee-validate'
import VueLocalforage from 'v-localforage'
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import CKEditor from '@ckeditor/ckeditor5-vue';
// Maps library
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import Print from 'vue-print-nb'
import VueCountryCode from "vue-country-code";

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
//pagination
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import '../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';

Vue.use(Print);
Vue.use(VueLocalforage, {
  instances: [
    {
      storeName: 'ttjdtbb486b51c9842efdaecd194'
    },
    {
      storeName: 'df5c729d64ed93b36cbbbff41f179'
    },
    {
      storeName: 'cj47054b89dc6c1f821c6e38d'
    },
    {
      storeName:  'a4316afd1e99295017d654'
    }


  ],
})

const VueValidationEs = require('vee-validate/dist/locale/es');
Vue.use(VeeValidate, {
    locale: 'es',
    dictionary: {
      es: VueValidationEs
    }
});

Vue.use( CKEditor );

Vue.config.productionTip = false
Vue.use(VueTimepicker)
Vue.use(DatePicker)
Vue.use(VueCountryCode);
Vue.component('apexchart', VueApexCharts)
Vue.use(Vuetify)
Vue.use(UUID)

// Moment translate

const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})

.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

// Icons for Leafleft Maps
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  i18n: i18n,
  components: { App },
  template: '<App/>',
  store: store
})


Vue.http.interceptor.before = (request, next) => {
  console.log(request);
  // cl router.app.encrypt({attributes: {user_id: 1,from: "16-05-2019", until: "17-05-2019",init_hour:"08:00",finish_hour:"16:00",available_locations:[1,5],offset_time:new Date().getTimezoneOffset()},invited_users_attributes:[{email:"alguien51@yopmail.com"}]}).toString()
  router.app.updateLoader(true)
  next((response) => {
    console.log(response);
    router.app.updateLoader(false)
    if(response.status == 401){
      router.app.$router.push({name: 'root'})
      router.app.updateIsLogin(false)
      if(response.body.meta != undefined && response.body.meta != null){
        if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
          router.app.checkToken(response.body.meta.authentication_token)
        }
      }
      alert("Tu sesión ha vencido, vuelve a ingresar para continuar")
    }
  })
}

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.userInfoType.includes(router.app.getUserType()))){
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js